/** User-facing name for the Stratos investigations agent. */
export const AGENT_DISPLAY_NAME = "Stratos";
